import { AmeraAES } from './utils/ameraWebCrypto';

onmessage = async (event) => {
  console.log('event', event);
  const { type, key, data } = event.data[1];
  if (type === 'encrypt') {
    await encrypt(event.data[0], key, data);
  } else if (type === 'decrypt') {
    await decrypt(event.data[0], key, data);
  }
};

const encrypt = async (messageId, key, data) => {
  try {
    const ameraAES = new AmeraAES({
      key,
      context: self /* eslint-disable-line no-restricted-globals */,
    });
    let encryptedData = await ameraAES.encrypt(data, {
      mode: 'utf8',
      verbose: false,
      cipher: 'utf8',
    });
    postMessage([messageId, null, encryptedData]);
  } catch (e) {
    console.log('worker issue', e);
    postMessage([messageId, null, data]);
  }
};

const decrypt = async (messageId, key, data) => {
  try {
    const ameraAES = new AmeraAES({
      key,
      context: self /* eslint-disable-line no-restricted-globals */,
    });
    let decryptedData = await ameraAES.decrypt(data, {
      mode: 'utf8',
      verbose: false,
      cipher: 'utf8',
    });

    postMessage([messageId, null, decryptedData]);
  } catch (e) {
    console.log('worker issue', e);
    postMessage([messageId, null, data]);
  }
};
